import { Icon } from "@pepperstone/pepper-ui-kit";
import type { ReactNode } from "react";
import styles from "./Accordion.module.css";

type HeaderWithIconProps = {
  children: ReactNode;
};

export const AccordionHeaderWithIcon = ({ children }: HeaderWithIconProps) => {
  return (
    <div className={styles.headerContent}>
      <span>{children}</span>
      <div className={styles.icon}>
        <Icon icon="arrow-down" />
      </div>
    </div>
  );
};
